var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80.6 117.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.7;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#343838;}.cls-5{opacity:0.6;fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.1,
    y1: 109.99,
    x2: 49.1,
    y2: 89.66,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343838",
    stopOpacity: 0,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343838",
    stopOpacity: 0.07,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343838",
    stopOpacity: 0.3,
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.31,
    y1: 109.99,
    x2: 32.31,
    y2: 89.66,
    xlinkHref: "#linear-gradient",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 80.83,
    y1: 0.37,
    x2: 71.83,
    y2: 9.12,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00DFFC",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFC",
    stopOpacity: 0,
    fill: "#343838"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sent invoice0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.6,117.48V95a5.94,5.94,0,1,0-11.87,0v11.41H17.6v11.1Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,95v5.68H0V95A5.94,5.94,0,0,1,5.94,89H64.62A11.6,11.6,0,0,0,63,95Z",
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.6,0V71.68H68.73V83.09a5.94,5.94,0,1,0,11.87,0V0ZM62.42,30.64a2.2,2.2,0,0,1-2,1.36H55V51.7a2.93,2.93,0,0,1-2.93,2.93h-8a2.93,2.93,0,0,1-2.93-2.93V47.93h0V32H35.81a2.2,2.2,0,0,1-1.55-3.75L46.55,15.95a2.2,2.2,0,0,1,3.11,0L61.95,28.24A2.2,2.2,0,0,1,62.42,30.64Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63,83.09V77.41H0v5.68A5.94,5.94,0,0,0,5.94,89H64.62A11.6,11.6,0,0,1,63,83.09Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "62.13 1 79.6 1 79.6 19.11 62.13 1",
    fill: "#343838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.1fcd61eb02a92c0133e995c093c1b692.svg";
export { ForwardRef as ReactComponent };